<template>
  <div class="header">
    <div class="nav" :class="isTransparent ? 'transparent' : 'no-transparent'">
      <div class="left" @click="$router.push({ path:'/wap-home' })">
        <div>
          <img src="~@/assets/logo.png" />
        </div>
      </div>
      <div class="right">
        <div>
          <img src="~@/assets/wap/menu.png" @click="onChangHeaderDetail(isShow)" />
        </div>
      </div>
    </div>
    <div id="detail" v-show="isShow" :class="[isTransparent ? 'transparent' : 'no-transparent' ]">
      <div @click="$emit('update:isShow', false)">
        <router-link to="/wap-home">首页</router-link>
      </div>
      <div @click="$emit('update:isShow', false)">
        <router-link to="/wap-project">项目历程</router-link>
      </div>
      <div @click="$emit('update:isShow', false)">
        <router-link to="/wap-product">产品介绍</router-link>
      </div>
      <div @click="$emit('update:isShow', false)">
        <router-link to="/wap-honor">荣誉资质</router-link>
      </div>
      <div @click="$emit('update:isShow', false)">
        <router-link to="/wap-about">关于我们</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wap-header",
  props: {
    //  是否透明
    isTransparent: { type: Boolean, default: false },
    //  是否显示
    isShow: { type: Boolean, default: false }
  },
  data () {
    return {
      isheaderShow: false
    }
  },
  methods: {
    onChangHeaderDetail (e) {
      this.isheaderShow = !e
      this.$emit('update:isShow', this.isheaderShow)
    }
  }
}
</script>

<style scoped lang="stylus">
.header {
  overflow: visible;
}

.transparent {
  opacity: 0.9 !important;
}

.no-transparent {
  opacity: 0.5 !important;
}

.nav {
  height: 80px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9;
  background-color: rgba(0, 0, 0, 1);

  .left {
    margin-left: 20px;

    div {
      height: 32px;
      width: 192px;

      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }

  .right {
    margin-right: 20px;

    div {
      width: 28px;
      height: 32px;
    }

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}

.hidden {
  display: none;
}

.show {
  display: block;
}

#detail {
  font-size: 30px;
  top: 87px;
  width: 260px;
  position: fixed;
  right: 5px;
  background-color: rgba(0, 0, 0, 1);
  opacity: 0.5;
  z-index: 9;
  border-radius: 10px;

  div {
    border-bottom: 1px solid #FFF;

    a {
      width: 260px;
      font-weight: bold;
      display: block;
      color: #B3B3B3;
      text-decoration: none;
      text-align: center;
      line-height: 80px;
      

      &.router-link-exact-active {
        width: 260px;
        color: #FFF;
      }
    }
  }

  div:last-child {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// wapHeader.vue